<div>

  <div style="display: grid; grid-template-columns: 1fr 40px;">
    <div style="height: 400px; overflow-y: scroll;">
      <div [style.height.px]="chartHeight">
        <canvas id="graph-canvas"></canvas>
      </div>
    </div>
    <div>
      <button class="btn" type="button" [disabled]="!enableZoomInChart" (click)="zoomInChart()">
        <i class="fa fa-plus"></i>
      </button>
      <br />
      <button class="btn" type="button" [disabled]="!enableZoomOutChart" (click)="zoomOutChart()">
        <i class="fa fa-minus"></i>
      </button>
    </div>
  </div>

  <p-table class="ping-history-table history-table" [value]="entries" [scrollable]="true" scrollHeight="calc(380px - 49px)"
    [resizableColumns]="true">
    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn>Device Name</th>
        <th pResizableColumn>IP Address</th>
        <th pResizableColumn>Timestamp</th>
        <th pResizableColumn>Has Reply</th>
        <th pResizableColumn>Pings / Replies</th>
        <th pResizableColumn>Response Time (ms)</th>
        <th pResizableColumn>SNMP Up Time</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        @if (rowGroupMetadata[rowData.groupKey].index === rowIndex) {
          <td
            [attr.rowspan]="rowGroupMetadata[rowData.groupKey].size"
            class="history-entry">
            <div class="uv-table-value">{{rowData.deviceName}}</div>
          </td>
        }
        @if (rowGroupMetadata[rowData.groupKey].index === rowIndex) {
          <td
            [attr.rowspan]="rowGroupMetadata[rowData.groupKey].size"
            class="history-entry">
            <div class="uv-table-value">{{rowData.ipAddress}}</div>
          </td>
        }
        <td pTooltip="{{formatDateHm(rowData.timestamp)}}">
          <div class="uv-table-value">{{formatDateHm(rowData.timestamp)}}</div>
        </td>
        <td>
          @switch (rowData.reply) {
            @case ('UP') {
              <img class="status-image" src="/images/status_up.png" />
            }
            @default {
              <img class="status-image" src="/images/status_down.png" />
            }
          }
        </td>
        <td>
          <div class="uv-table-value">{{rowData.pingStats}}</div>
        </td>
        <td>
          <div class="uv-table-value">{{rowData.rtt}}</div>
        </td>
        <td>
          <div class="uv-table-value">{{rowData.snmpSysUpTime}}</div>
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>
